export enum STATIC_COLUMNS {
  STATUS = "isActive",
  ACTION = "action",
  PLATEFORM = "platform",
  SHOW_WITH_IMAGE = "showWithImage",
  ID = "id",
}
